/* cb 2026-05-31T11:24:04.663656 */
/* gatsby-quiet-mind-ritual.js
 * Light interactions for the Quiet Mind Ritual LP:
 *  - Auto-scrolling UGC marquee (chapter 04)
 *  - Science tab toggle (chapter 17)
 *  - UGC swipe carousel (chapter 05)
 *  - Smooth scroll to #productSection for CTA anchors
 *
 * NOTE: each chapter section emits its own <article class="hbr-adv"> wrapper,
 * so we use document-level queries. A single-root querySelector would only see
 * the FIRST chapter's article (chapter 01: announce + masthead) and miss every
 * other chapter's interactive elements. Don't scope handlers to one `root`.
 */
(function() {
  'use strict';

  // Bail early if no QMR section is on this page
  if (!document.querySelector('.hbr-adv')) return;

  // ───── Auto-scrolling marquee (chapter 04) ─────
  // JS clones the children once, then drives the loop at a FIXED px/sec by measuring
  // the real rendered width and computing the duration. This makes the speed identical
  // on the Theme-Editor preview and a real phone (a fixed CSS duration looked far faster
  // on mobile because the track + cells are narrower there).
  var MARQUEE_PXPS = 32; // pixels/second — the calm desktop pace, locked for every viewport
  document.querySelectorAll('.hbr-adv [data-marquee]').forEach(function(track) {
    if (track.children.length === 0) return;
    if (track.hasAttribute('data-marquee-active')) return;
    var originals = Array.prototype.slice.call(track.children);
    originals.forEach(function(child) {
      var clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    track.setAttribute('data-marquee-active', '');
    function syncMarquee() {
      var w = 0;
      originals.forEach(function(child) {
        var cs = getComputedStyle(child);
        w += child.getBoundingClientRect().width + (parseFloat(cs.marginRight) || 0) + (parseFloat(cs.marginLeft) || 0);
      });
      if (w > 0) {
        track.style.setProperty('--mq-distance', w + 'px');
        track.style.animationDuration = (w / MARQUEE_PXPS).toFixed(2) + 's';
      }
    }
    syncMarquee();
    var mqResizeT;
    window.addEventListener('resize', function () { clearTimeout(mqResizeT); mqResizeT = setTimeout(syncMarquee, 150); });
    // Touch: pause while a finger rests on the strip, resume the instant it lifts.
    track.addEventListener('touchstart', function () { track.style.animationPlayState = 'paused'; }, { passive: true });
    var mqResume = function () { track.style.animationPlayState = 'running'; };
    track.addEventListener('touchend', mqResume, { passive: true });
    track.addEventListener('touchcancel', mqResume, { passive: true });
  });

  // ───── Science tabs (chapter 17) ─────
  document.querySelectorAll('.hbr-adv [data-tabs]').forEach(function(group) {
    var tabs = group.querySelectorAll('.nc-tabs__tab');
    var panels = group.querySelectorAll('.nc-tabs__panel');
    // Preload each tab's media image up-front (inactive panels are display:none, so
    // their images would otherwise only fetch on first reveal — the blank-then-pop).
    group.querySelectorAll('.nc-science__media-item img').forEach(function(im) {
      var s = im.getAttribute('src');
      if (s) { var pre = new Image(); pre.decoding = 'async'; pre.src = s; }
    });
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function(t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function(p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === target); });
      });
    });
  });

  // ───── UGC swipe carousel (chapter 05) ─────
  document.querySelectorAll('.hbr-adv [data-ugc-carousel]').forEach(function(group) {
    var track = group.querySelector('[data-ugc-track]');
    var prev = group.querySelector('[data-ugc-prev]');
    var next = group.querySelector('[data-ugc-next]');
    if (!track || !prev || !next) return;
    function step(dir) {
      var card = track.querySelector('.ph');
      var w = card ? card.getBoundingClientRect().width + 14 : 280;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    prev.addEventListener('click', function() { step(-1); });
    next.addEventListener('click', function() { step(1); });
    function updateArrows() {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  });

  // ───── Mechanism timeline accordion (chapter 07) ─────
  // Each step row toggles independently (multiple can be open). First step is
  // pre-opened server-side via .is-open + aria-expanded="true".
  function mechOpen(inner) {
    inner.style.maxHeight = inner.scrollHeight + 'px';
    var done = function (e) { if (e.propertyName === 'max-height') { inner.style.maxHeight = 'none'; inner.removeEventListener('transitionend', done); } };
    inner.addEventListener('transitionend', done);
  }
  function mechClose(inner) {
    inner.style.maxHeight = inner.scrollHeight + 'px';
    inner.offsetHeight; // reflow so the change to 0 animates
    inner.style.maxHeight = '0px';
  }
  // Lock initial heights so the default-open step doesn't animate on load.
  document.querySelectorAll('.hbr-adv [data-mech-accordion] .nc-mech-step').forEach(function(step) {
    var inner = step.querySelector('.nc-mech-step__panel-inner');
    if (inner) inner.style.maxHeight = step.classList.contains('is-open') ? 'none' : '0px';
  });
  document.querySelectorAll('.hbr-adv [data-mech-accordion] [data-mech-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var step = btn.closest('.nc-mech-step');
      if (!step) return;
      var open = step.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var inner = step.querySelector('.nc-mech-step__panel-inner');
      if (inner) { if (open) mechOpen(inner); else mechClose(inner); }
    });
  });

  // ───── CTA anchor smooth-scroll (any chapter) ─────
  document.querySelectorAll('.hbr-adv a[href="#productSection"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.getElementById('productSection');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ───── Explore-collections nudge: click gently wiggles the 4 collection cards ─────
  document.querySelectorAll('.hbr-adv [data-hbr-wiggle-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var cards = document.querySelectorAll('.hbr-adv .hbr-grid__card');
      cards.forEach(function (c) { c.classList.remove('is-wiggle'); });
      if (cards[0]) void cards[0].offsetWidth; // reflow so repeat clicks restart the animation
      cards.forEach(function (c) { c.classList.add('is-wiggle'); });
      clearTimeout(btn._wiggleT);
      btn._wiggleT = setTimeout(function () { cards.forEach(function (c) { c.classList.remove('is-wiggle'); }); }, 1100);
    });
  });
})();

/* ============================================================
   Collections picker (series gallery + lightbox) — chapter 10
   Vanilla port of the Alpine "browser()" component from
   draft_series-picker_v1_claude. No Alpine. Renders tiles
   dynamically from #hbr-picker-data; one accordion open at a time;
   lightbox with crossfade prev/next, keyboard, body scroll lock.
   ============================================================ */
(function() {
  'use strict';

  var dataEl = document.getElementById('hbr-picker-data');
  if (!dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }


  // Display order, copy, and reserved-slot count per series.
  // `totalSlots` pads the grid with "Coming Soon" placeholders.
  var CONFIG = {
    calmingnature: { title: 'Calming Nature', tagline: 'Animals, blooms, and quiet scenes — the original Gatsby calm.', mood: 'Animals, blooms, and quiet scenes', totalSlots: 11 },
    talesofjapan2: { title: 'Tales of Japan', tagline: 'Inspired by iconic Japanese scenery, waves, mountains, and timeless beauty.', mood: 'Waves, temples, and sunlit drama', totalSlots: 7 },
    canvas:        { title: 'Midnight Cities', tagline: 'Iconic skylines that glow as you scratch them open.', mood: 'Skylines and after-dark glow', totalSlots: 30 },
    wildlife:      { title: 'Wildlife Series', tagline: 'Four-piece sets that bring the wild kingdom indoors.', mood: 'Bold animals with vivid detail', totalSlots: 16 }
  };
  var ORDER = ['calmingnature', 'talesofjapan2', 'canvas', 'wildlife'];

  // Build the enriched series list (mirrors Alpine init()).
  var seriesList = ORDER.map(function(h) {
    var s = data[h];
    if (!s) return null;
    var cfg = CONFIG[h] || {};
    return {
      handle: s.handle,
      title: cfg.title || s.title,
      tagline: cfg.tagline || '',
      mood: cfg.mood || cfg.tagline || '',
      designs: s.designs || [],
      realCount: (s.designs || []).length,
      totalSlots: cfg.totalSlots || (s.designs || []).length
    };
  }).filter(Boolean);
  if (!seriesList.length) return;

  function shortName(name) {
    return name.split(' - ')[0].split(' (')[0].trim();
  }
  function productUrl(handle, variantId) {
    return '/products/' + handle + '?variant=' + variantId;
  }
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Render one series accordion item -> HTML string (Artwork Peek Accordion).
  // ctaMode: 'explore' (link to /products/{handle}) or 'preview' (open lightbox).
  function renderSeries(s, idx, ctaMode) {
    var countMore = s.totalSlots > s.realCount ? ' of ' + s.totalSlots : '';
    var heroImg = s.designs[0] ? s.designs[0].image : '';
    // Closed-row artwork peek (representative = first design), tilted, framed.
    var peek = heroImg
      ? '<span class="hbr-picker__peek" aria-hidden="true"><img src="' + esc(heroImg) + '" alt="" loading="lazy"></span>'
      : '';
    // Open-state tilted preview cards — first 4 designs, click opens the lightbox.
    var cards = '';
    s.designs.slice(0, 4).forEach(function(d, i) {
      cards += '<button class="hbr-picker__card" type="button" data-design-index="' + i + '" aria-label="View ' + esc(shortName(d.name)) + '" style="--qp-i:' + i + '">' +
                 '<img class="hbr-picker__card-img" src="' + esc(d.image) + '" alt="' + esc(d.name) + '" loading="lazy">' +
               '</button>';
    });

    // CTA: 'preview' opens the lightbox (button), 'explore' links to the PDP (anchor).
    var cta = (ctaMode === 'preview')
      ? '<button class="hbr-picker__browse" type="button" data-series-preview>' +
          '<span>Preview Collection</span>' +
          '<span class="hbr-picker__browse-arrow">→</span>' +
        '</button>'
      : '<a class="hbr-picker__browse" href="/products/' + esc(s.handle) + '">' +
          '<span>Explore Collection</span>' +
          '<span class="hbr-picker__browse-arrow">→</span>' +
        '</a>';

    return '<section class="hbr-picker__series' + (idx === 0 ? ' is-open' : '') + '" data-series-handle="' + esc(s.handle) + '">' +
             '<button class="hbr-picker__head" type="button" data-series-toggle>' +
               '<div class="hbr-picker__titlewrap">' +
                 '<h3 class="hbr-picker__series-title">' + esc(s.title) + '</h3>' +
                 '<span class="hbr-picker__count">' + s.realCount + countMore + ' designs</span>' +
               '</div>' +
               peek +
               '<span class="hbr-picker__chev" aria-hidden="true">▾</span>' +
             '</button>' +
             '<div class="hbr-picker__expand"><div class="hbr-picker__expand-inner"><div class="hbr-picker__body">' +
               (heroImg ? '<div class="hbr-picker__hero"><img src="' + esc(heroImg) + '" alt="' + esc(s.title) + '" loading="lazy"></div>' : '') +
               '<p class="hbr-picker__sub">' + esc(s.tagline) + '</p>' +
               '<div class="hbr-picker__cards">' + cards + '</div>' +
               cta +
             '</div></div></div>' +
           '</section>';
  }

  // Render one collection as a grid card (grid/"mood" layout) -> HTML string.
  // Tapping the card opens the preview lightbox at design 0.
  function renderGridCard(s) {
    var img = s.designs[0] ? s.designs[0].image : '';
    return '<button class="hbr-grid__card" type="button" data-grid-handle="' + esc(s.handle) + '" aria-label="Preview ' + esc(s.title) + '">' +
             '<span class="hbr-grid__card-img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(s.title) + '" loading="lazy">' : '') + '</span>' +
             '<span class="hbr-grid__card-row">' +
               '<span class="hbr-grid__card-text">' +
                 '<span class="hbr-grid__card-title">' + esc(s.title) + '</span>' +
                 '<span class="hbr-grid__card-desc">' + esc(s.mood) + '</span>' +
               '</span>' +
               '<span class="hbr-grid__card-arrow" aria-hidden="true">→</span>' +
             '</span>' +
           '</button>';
  }

  // Initialize every picker instance on the page (scope queries to .hbr-adv).
  document.querySelectorAll('.hbr-adv [data-hbr-picker]').forEach(function(root) {
    var seriesMount = root.querySelector('[data-picker-series]');
    if (!seriesMount) return;

    // Inject markup. layout = 'accordion' (default) or 'grid'; CTA mode per-instance.
    var ctaMode = root.getAttribute('data-cta-mode') || 'explore';
    var layout = root.getAttribute('data-layout') || 'accordion';
    if (layout === 'grid') {
      var serverCards = seriesMount.querySelectorAll('.hbr-grid__card');
      if (serverCards.length) {
        // Cards are server-rendered + editable per-card. Fill any blank image from the catalog cover.
        Array.prototype.forEach.call(serverCards, function (gc) {
          var h = gc.getAttribute('data-grid-handle');
          var im = gc.querySelector('img');
          if (im && !im.getAttribute('src') && data[h] && data[h].designs[0]) im.src = data[h].designs[0].image;
        });
      } else {
        // Legacy fallback: render the catalog collections (no per-card settings present).
        seriesMount.innerHTML = '<div class="hbr-grid">' + seriesList.map(renderGridCard).join('') + '</div>';
      }
    } else {
      seriesMount.innerHTML = seriesList.map(function (s, i) {
        return renderSeries(s, i, ctaMode);
      }).join('');
    }

    // ── Accordion: one open at a time, first open by default ──
    var sections = seriesMount.querySelectorAll('.hbr-picker__series');
    sections.forEach(function(sec) {
      var head = sec.querySelector('[data-series-toggle]');
      if (head) {
        head.addEventListener('click', function() {
          var willOpen = !sec.classList.contains('is-open');
          sections.forEach(function(other) { other.classList.remove('is-open'); });
          if (willOpen) sec.classList.add('is-open');
        });
      }
      // ── "Preview {series}" button → opens the lightbox at design 0 ──
      var previewBtn = sec.querySelector('[data-series-preview]');
      if (previewBtn) {
        previewBtn.addEventListener('click', function() {
          var handle = sec.getAttribute('data-series-handle');
          if (handle) openLightbox(handle, 0);
        });
      }
    });

    // ── Lightbox ──
    var lb = root.querySelector('[data-picker-lb]');
    if (!lb) return;
    // Portal the lightbox to <body> so its position:fixed is relative to the
    // viewport, not a transformed/contained ancestor (chapter wrappers, the
    // Theme Editor preview transform, etc. would otherwise offset it). CSS for
    // .hbr-picker__lb* is unscoped so it still applies at body level.
    if (lb.parentElement !== document.body) document.body.appendChild(lb);
    var imgA = lb.querySelector('[data-picker-lb-img-a]');
    var imgB = lb.querySelector('[data-picker-lb-img-b]');
    var imgWrap = lb.querySelector('[data-picker-lb-imgwrap]');
    var counterEl = lb.querySelector('[data-picker-lb-counter]');
    var nameEl = lb.querySelector('[data-picker-lb-name]');
    var seriesTitleEl = lb.querySelector('[data-picker-lb-seriestitle]');
    var ctaEl = lb.querySelector('[data-picker-lb-cta]');
    var ctaLabelEl = lb.querySelector('[data-picker-lb-cta-label]');
    var closeBtn = lb.querySelector('[data-picker-lb-close]');
    var prevBtn = lb.querySelector('[data-picker-lb-prev]');
    var nextBtn = lb.querySelector('[data-picker-lb-next]');
    var card = lb.querySelector('[data-picker-lb-card]');

    var state = { handle: null, index: 0, layer: 'A', open: false };

    function seriesFor(handle) { return data[handle] || null; }
    function designFor() {
      var s = seriesFor(state.handle);
      if (!s || !s.designs[state.index]) return null;
      return s.designs[state.index];
    }

    function preloadNeighbors() {
      var s = seriesFor(state.handle);
      if (!s) return;
      var n = s.designs.length;
      [(state.index - 1 + n) % n, (state.index + 1) % n].forEach(function(i) {
        var im = new Image(); im.src = s.designs[i].image;
      });
    }

    function syncCaption() {
      var s = seriesFor(state.handle);
      var d = designFor();
      if (counterEl) counterEl.textContent = s ? (state.index + 1) + ' / ' + s.designs.length : '';
      if (nameEl) nameEl.textContent = d ? shortName(d.name) : '';
      if (seriesTitleEl) seriesTitleEl.textContent = s ? s.title : '';
      if (ctaLabelEl) ctaLabelEl.textContent = s ? (layout === 'grid' ? 'Pick ' + s.title + ' designs' : 'Buy ' + s.title) : (layout === 'grid' ? 'Pick designs' : 'Buy');
      if (ctaEl) ctaEl.setAttribute('href', (d && d.url && d.url !== '#') ? d.url : ((s && d && d.variants && d.variants[0]) ? productUrl(s.handle, d.variants[0].id) : '#'));
      if (lb) lb.setAttribute('aria-label', d ? shortName(d.name) : '');
    }

    // Size the frame to the image's natural ratio so nothing is cropped.
    function applyRatio(img) {
      if (!imgWrap || !img || !img.naturalWidth || !img.naturalHeight) return;
      imgWrap.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
      // Feed the ratio to CSS so max-width can clamp in lock-step with the 64vh
      // height cap on tall portrait images (prevents grey side-bars on mobile).
      imgWrap.style.setProperty('--lb-ratio', (img.naturalWidth / img.naturalHeight));
    }
    function applyRatioWhenReady(img) {
      if (img.complete && img.naturalWidth) { applyRatio(img); }
      else { img.onload = function () { applyRatio(img); }; }
    }

    function openLightbox(handle, index) {
      state.handle = handle;
      state.index = index;
      state.layer = 'A';
      var img = data[handle].designs[index].image;
      imgA.src = img;
      imgA.alt = data[handle].designs[index].name;
      applyRatioWhenReady(imgA);
      imgB.removeAttribute('src');
      imgB.alt = '';
      imgA.classList.add('is-on');
      imgB.classList.remove('is-on');
      state.open = true;
      lb.classList.add('is-on');
      lb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lb-open');
      syncCaption();
      preloadNeighbors();
    }

    function closeLightbox() {
      state.open = false;
      lb.classList.remove('is-on');
      lb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lb-open');
    }

    function crossfadeTo(newIdx) {
      var s = seriesFor(state.handle);
      if (!s) return;
      var newImg = s.designs[newIdx].image;
      var newName = s.designs[newIdx].name;
      // Load into the INACTIVE layer first.
      var target = state.layer === 'A' ? 'B' : 'A';
      var targetImg = target === 'A' ? imgA : imgB;
      var otherImg = target === 'A' ? imgB : imgA;
      targetImg.src = newImg;
      targetImg.alt = newName;
      applyRatioWhenReady(targetImg);
      state.index = newIdx;
      syncCaption();
      // Next frame: flip the active layer so CSS crossfades both opacities.
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          targetImg.classList.add('is-on');
          otherImg.classList.remove('is-on');
          state.layer = target;
          preloadNeighbors();
        });
      });
    }

    function next() {
      var s = seriesFor(state.handle);
      if (!s) return;
      crossfadeTo((state.index + 1) % s.designs.length);
    }
    function prev() {
      var s = seriesFor(state.handle);
      if (!s) return;
      var n = s.designs.length;
      crossfadeTo((state.index - 1 + n) % n);
    }

    // Card clicks open the lightbox (delegated to the mount).
    seriesMount.addEventListener('click', function(e) {
      // Grid layout: tapping a collection card opens the preview at design 0.
      var gcard = e.target.closest('.hbr-grid__card');
      if (gcard) {
        var ghandle = gcard.getAttribute('data-grid-handle');
        if (data[ghandle]) openLightbox(ghandle, 0);
        return;
      }
      var card = e.target.closest('.hbr-picker__card');
      if (!card) return;
      var sec = card.closest('.hbr-picker__series');
      if (!sec) return;
      var handle = sec.getAttribute('data-series-handle');
      var index = parseInt(card.getAttribute('data-design-index'), 10);
      if (!data[handle] || isNaN(index)) return;
      openLightbox(handle, index);
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    // Grid layout: secondary "Check out other collections" button just closes the popup.
    var close2Btn = lb.querySelector('[data-picker-lb-close2]');
    if (close2Btn) close2Btn.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); next(); });
    // Click-outside (backdrop) closes; clicks inside the card do not.
    lb.addEventListener('click', function(e) {
      if (e.target === lb) closeLightbox();
    });
    if (card) card.addEventListener('click', function(e) { e.stopPropagation(); });

    // Keyboard: Escape closes, arrows navigate when open.
    document.addEventListener('keydown', function(e) {
      if (!state.open) return;
      if (e.key === 'Escape') { closeLightbox(); }
      else if (e.key === 'ArrowLeft') { prev(); }
      else if (e.key === 'ArrowRight') { next(); }
    });
  });
})();
